// This file was automatically generated from app.onboarding.learnMore.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.onboarding.learnMore');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.learnMore.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="learn-more-container" class="overlayContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.learnMore.requestForm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>Get simple, affordable pricing with the flexibility that suits your practice needs.</p><div class="el8Spacer"></div><p><a target="_blank" rel="noopener" href="https://www.elationhealth.com/pricing/?utm_campaign=in_app&amp;utm_source=learn_more">Learn More</a> about our pricing</p><form id="learn-more-form"><p>Send us your information and an Elation team member will contact you within 1 business day. Or call us directly at 1-888-974-5625.</p><div class="demoTextareaWrap"><textarea type="text" name="name" placeholder="Name" class="fieldInputText w100"></textarea></div><div class="demoTextareaWrap"><textarea type="text" name="email" placeholder="Email Address" class="fieldInputText w100"></textarea></div><div class="demoTextareaWrap"><textarea type="text" name="phone" placeholder="Phone Number" class="fieldInputText w100"></textarea></div><div class="demoTextareaWrap"><textarea type="text" name="message" placeholder="Question or comment?" class="fieldInputText w100"></textarea></div><div class="requestButtonContainer"><button type="button" class="newButton submit-trigger">Send</button></div></form><p class="el8AlignCenter mt10"><a class="external-site-trigger">Visit Elation Health\'s website for more info</a></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.learnMore.successContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8Spacer"></div><div class="submitConfirmation">Request submitted.</div><p class="el8AppText">Thank you for your interest in Elation Health! We\'ll contact you shortly to help answer any questions you may have about Elation.</p><p class="el8AppText">In the meantime, please visit our website, <a href="http://www.elationemr.com/?utm_campaign=in_app&amp;utm_source=learn_more">www.elationemr.com</a>, for more information about Elation Health.</p><div class="el8Spacer"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.onboarding.learnMore.errorContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div>Sorry!  We were unable to submit your request. Please <a class="reset-form-trigger">try again</a>.</div><p class="el8AppText">If you continue to experience trouble please give us a call directly at 1-888-974-5625 or <a href="https://help.elationhealth.com/s/contactsupport">contact us</a>.</p><button type="button" class="reset-form-trigger">Try again</button></div>');
  if (!opt_sb) return output.toString();
};
